import { createFileRoute } from '@tanstack/react-router';
import { LocationEditPage } from '@/features/locations/LocationEditPage';

export const Route = createFileRoute('/app/board/$locationId_/edit')({
  component: EditRoute,
  staticData: { title: 'Edit site' },
});

function EditRoute() {
  const { locationId } = Route.useParams();
  return <LocationEditPage key={locationId} locationId={locationId} />;
}
